import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux';
import { formattedDate, refundFormattedDate } from '../../utils/formattedDate';
import { PAYMENT_STATUS, PAYMENT_PLAN, USER_PAYMENT_TYPE } from '../../constants/common';
import { getSingleTransactionApi, refundAmountApi } from '../../api/usersApi';

import dummyFounder from '../../assets/images/dummyFounder.png'

const EditTransaction = ({ setEditTransaction, ref, selectedTransaction, isEditTransaction, transactionApi, setTransactionList, setNotificationMessage, setShowNotification, LazyImage, setSelectedTransaction }) => {
    const [amount, setAmount] = useState('')
    const [reason, setReason] = useState('')
    const [signleTransactionData, setSingleTransactionData] = useState([])
    const [isLoadingData, setIsLoadingData] = useState(true);
    const [isRefundLoading, setIsRefundLoading] = useState(false)
    const [showRefunds, setShowRefunds] = useState(false);
    const [errorMessage, setErrorMessage] = useState({
        amount: '',
        reason: '',
        refundError: '',
    })

    const paymentStatus = PAYMENT_STATUS;
    const userPlan = PAYMENT_PLAN;
    const paymentType = USER_PAYMENT_TYPE;

    const statusLabel = paymentStatus?.find((item) => item?.key === signleTransactionData?.status)?.value;
    const planLabel = userPlan?.find((item) => item?.key === selectedTransaction?.plan)?.value;
    const typeLabel = paymentType?.find((item) => item?.key === selectedTransaction?.userType)?.value;
    const totalRefunded = signleTransactionData?.refundPayment?.reduce((sum, r) => sum + r?.refundamount, 0);

    useEffect(() => {
        if (selectedTransaction?.id) {
            const fetchData = async () => {
                try {
                    setIsLoadingData(true);
                    const res = await getSingleTransactionApi(selectedTransaction?.id, selectedTransaction?.stripePaymentId);
                    if (res) {
                        setSingleTransactionData(res);
                    }
                } catch (error) {
                    console.log(error);
                    setIsLoadingData(false);
                }
            }
            fetchData();
        }
    }, [selectedTransaction?.id])

    useEffect(() => {
        if (signleTransactionData && signleTransactionData !== undefined) {
            setTimeout(() => {
                setIsLoadingData(false);
            }, 3000);
        }
    }, [signleTransactionData]);

    useEffect(() => {
        if (isEditTransaction === true) {
            setAmount('');
            setReason('');
            setErrorMessage({
                amount: '',
                reason: ''
            });
            setShowRefunds(false)
        }
    }, [isEditTransaction])

    useEffect(() => {
        if (!isEditTransaction) {
            setSelectedTransaction({})
        }
    }, [isEditTransaction])

    useEffect(() => {
        if (isEditTransaction) {
            const scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
        } else {
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }
    }, [isEditTransaction]);

    const refundAmount = async () => {
        let success = false;
        setIsRefundLoading(false);
        try {
            setIsRefundLoading(true);
            success = await refundAmountApi({
                userId: selectedTransaction?.userId,
                paymentId: selectedTransaction?.id,
                refundAmount: Number(amount),
                reason,
            });
            if (success) {
                const data = await transactionApi();
                if (data) {
                    setTransactionList(data?.list)
                    setEditTransaction(false);
                    setShowNotification(true);
                    setNotificationMessage(`A refund of $${amount} has been issued to ${selectedTransaction?.userName}.`)
                    setTimeout(() => {
                        setShowNotification(false)
                    }, 8000)
                    setIsRefundLoading(false);
                }
            }
        } catch (error) {
            console.log(error)
            const errMsg = error?.response?.data?.message;
            setErrorMessage((prev) => ({
                ...prev,
                refundError: errMsg,
            }));
            setIsRefundLoading(false);
            return false;
        }
    }

    const handleRefund = async () => {
        let isValid = true;

        const newErrors = {
            amount: '',
            reason: ''
        };

        const numericAmount = parseFloat(amount);
        const maxAmount = signleTransactionData?.amount - totalRefunded;

        if (!amount?.trim()) {
            newErrors.amount = 'Please enter amount for refund.';
            isValid = false;
        } else if (isNaN(amount) || Number(amount) <= 0) {
            newErrors.amount = 'Please enter a valid number.';
            isValid = false;
        } else if (maxAmount !== undefined && numericAmount > maxAmount) {
            newErrors.refundError = `Amount cannot be more than $${maxAmount.toFixed(2)}`;
            isValid = false;
        }

        if (!reason?.trim()) {
            newErrors.reason = 'Please enter reason for refund.';
            isValid = false;
        }

        setErrorMessage(newErrors);
        if (!isValid) return;

        const data = await refundAmount();
    }

    return (
        <>
            <div className={`${isEditTransaction && 'popup-overlay'}`}></div>
            <div className={`transaction-profile-popup ${isEditTransaction ? 'show' : ''}`} ref={ref}>
                <div className='popup-box'>
                    <div className="popup-close" onClick={() => { setEditTransaction(false) }}>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 1L1 13M1 1L13 13" stroke="#05171A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div
                        className={`pagesTable dataTable-list ${isLoadingData ? 'loading-list profile-data-loader' : ''
                            }`}
                    >
                        <div className='transaction-basic-info'>
                            <div className="transaction-number">
                                Payment #{signleTransactionData?.id}
                                <span className={`transaction-type transaction-status ${statusLabel}`}>{statusLabel}</span>
                            </div>
                            <div className='transaction-date'>{formattedDate(signleTransactionData?.createdAt)}</div>
                            <div className="user-details">
                                <div className="reported">
                                    <span className='label'>User</span>
                                    <div className="user-name">
                                        <div className='transaction-user-image'>
                                            <LazyImage
                                                src={signleTransactionData?.user?.profileImg || dummyFounder}
                                                alt="User Image"
                                            />
                                        </div>
                                        <div className='user-transaction-name'>{signleTransactionData?.user?.name}</div>
                                        <div className={`user-type ${typeLabel}`}>{typeLabel}</div>
                                        {(signleTransactionData?.user?.userStatus === 1 && signleTransactionData?.user?.step === 0) ?
                                            <div className='user-plan'>
                                                Active {`${planLabel ? `(${planLabel})` : ''}`}
                                            </div>
                                            : signleTransactionData?.user?.userStatus === 3 ?
                                                <div className='transaction-status Failed'>
                                                    Suspended {`${planLabel ? `(${planLabel})` : ''}`}
                                                </div>
                                                : (signleTransactionData?.user?.userStatus === 4 || signleTransactionData?.user?.userStatus === 5) ?
                                                    ''
                                                    :
                                                    <div className='transaction-status Refund'>
                                                        Not Completed {`${planLabel ? `(${planLabel})` : ''}`}
                                                    </div>

                                        }
                                    </div>
                                </div>
                                {
                                    signleTransactionData?.status === 'refunded' &&

                                    <div className="amount-block">
                                        <span className="label">Original payment</span>
                                        <div className="original-payment">
                                            <span >Payment #{selectedTransaction?.stripePaymentId}</span>
                                        </div>
                                    </div>
                                }

                                {
                                    signleTransactionData?.status === 'completed' &&
                                    <div className="amount-block">
                                        <div className="amount amount-list">
                                            <span>Payment amount</span>
                                            <span>
                                                ${signleTransactionData?.amount} {signleTransactionData?.currency?.toUpperCase()}
                                            </span>
                                        </div>
                                        <div className="refund-divider"></div>
                                        {totalRefunded > 0 &&
                                            <>
                                                <div className="amount amount-list refund-amount-list"
                                                    onClick={() => setShowRefunds(!showRefunds)}
                                                >
                                                    <span
                                                        className={`refund-dropdown ${showRefunds ? "open" : ""}`}
                                                    >
                                                        Refunded amount
                                                    </span>
                                                    {!showRefunds &&
                                                        <span>
                                                            - ${totalRefunded} {signleTransactionData?.currency?.toUpperCase()}
                                                        </span>
                                                    }
                                                </div>
                                                <div className="refund-divider"></div>
                                                <div
                                                    className={`refund-dropdown-container ${showRefunds ? "open" : ""}`}
                                                >
                                                    <ul className="refund-list">
                                                        {signleTransactionData?.refundPayment?.map((refund, index) => (
                                                            <>
                                                                <li className="amount-list">
                                                                    <div className="refund-amount">
                                                                        <span className="refund-reason">{refund?.refundreason}</span>
                                                                        <span>- ${refund?.refundamount} {signleTransactionData?.currency?.toUpperCase()}</span>
                                                                    </div>
                                                                    <div className="refund-amount">
                                                                        <span className="refund-date">{refundFormattedDate(refund?.refunddate)}</span>
                                                                    </div>
                                                                </li>
                                                                <div className="refund-divider refunded-border"></div>
                                                            </>
                                                        ))}
                                                    </ul>
                                                </div>

                                                <div className="amount amount-list">
                                                    <span className="net-amount">Net amount </span>
                                                    <span className="net-amount">
                                                        ${signleTransactionData.amount - totalRefunded} {signleTransactionData.currency?.toUpperCase()}
                                                    </span>
                                                </div>
                                                <div className="refund-divider"></div>
                                            </>

                                        }
                                    </div>
                                }

                                {
                                    signleTransactionData?.status === 'refunded' &&
                                    <div className="amount-block">
                                        <span className="label">
                                            Refund amount
                                        </span>
                                        <div className="amount">
                                            <span >
                                                ${signleTransactionData?.refundAmount || 0} {signleTransactionData?.currency?.toUpperCase()}
                                            </span>
                                        </div>
                                    </div>
                                }
                                {
                                    signleTransactionData?.status === 'failed' &&
                                    <div className="amount-block">
                                        <span className="label">
                                            Amount
                                        </span>
                                        <div className="amount">
                                            <span >
                                                ${signleTransactionData?.amount} {signleTransactionData?.currency?.toUpperCase()}
                                            </span>
                                        </div>
                                    </div>
                                }
                                {
                                    selectedTransaction?.status !== 'completed' &&
                                    <div className="amount-block">
                                        <span className="label">Reason</span>
                                        <div className="amount">
                                            <span >{signleTransactionData?.refundReason}</span>
                                        </div>
                                    </div>
                                }
                                <div className="stripe-block">
                                    <span className="label">Stripe</span>
                                    <div className="stripe">
                                        <a target="_blank" href={signleTransactionData?.portalUrl} className="truncate-url">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M8.47154 12.2403L7.52873 13.1831C6.22699 14.4849 4.11644 14.4849 2.81469 13.1831C1.51294 11.8814 1.51294 9.77085 2.81469 8.4691L3.7575 7.52629M12.2428 8.4691L13.1856 7.52629C14.4873 6.22455 14.4873 4.114 13.1856 2.81225C11.8838 1.5105 9.77329 1.5105 8.47154 2.81225L7.52873 3.75506M5.66681 10.331L10.3335 5.66435" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>{" "}
                                            {signleTransactionData?.portalUrl}
                                        </a>
                                    </div>
                                </div>
                                {
                                    signleTransactionData?.status === 'completed' &&
                                    <>
                                        <div className="divider stripe-link-divider"></div>
                                        <div className='transaction-suspend-section'>
                                            <div className='title'>Issue refund</div>
                                            <div className='description'>Issue a refund to {selectedTransaction?.userName}. You can choose to process a full or partial refund - funds will be returned to their original payment method.</div>
                                        </div>
                                        <div className={`amount-transaction input-group filled ${(errorMessage?.amount || errorMessage?.refundError) && 'show-error'}`}>
                                            <input className='payment-refund-amount' type="number" id='amount' name='amount' autoComplete="off" value={amount}
                                                onChange={(e) => {
                                                    const inputValue = e.target.value;
                                                    setAmount(inputValue);

                                                    if (errorMessage?.amount || errorMessage?.refundError) {
                                                        setErrorMessage(prev => ({ ...prev, amount: '', refundError: '' }));
                                                    }

                                                    const numericValue = parseFloat(inputValue);
                                                    const maxAmount = signleTransactionData?.amount - totalRefunded;
                                                    if (!isNaN(numericValue) && maxAmount !== undefined && numericValue > maxAmount) {
                                                        setErrorMessage(prev => ({
                                                            ...prev,
                                                            refundError: `Amount cannot be more than $${maxAmount?.toFixed(2)}`
                                                        }));
                                                    }
                                                }}
                                            />
                                            <label htmlFor="amount">Amount to refund</label>
                                            <span className='amount-sign'>$</span>
                                            <span className='amount-type'>USD</span>
                                        </div>
                                        {errorMessage?.amount && <p className="error-message">{errorMessage?.amount}</p>}
                                        {errorMessage?.refundError && <p className="error-message">{errorMessage?.refundError}</p>}

                                        <div className={`input-group ${reason ? 'filled' : ''}  ${errorMessage?.reason && 'show-error'}`}>
                                            <input type="text" id='reason' className='' name='reason' autoComplete="off" value={reason} onChange={(e) => {
                                                setReason(e.target.value);
                                                if (errorMessage?.reason) setErrorMessage(prev => ({ ...prev, reason: '' }));
                                            }} />
                                            <label htmlFor="reason">Reason to refund</label>
                                        </div>
                                        {errorMessage?.reason && <p className="error-message">{errorMessage?.reason}</p>}

                                        <div className='save-button-group'>
                                            <button
                                                className={`save-button button ${isRefundLoading ? 'btn_loading' : ''
                                                    }`}
                                                onClick={() => { handleRefund(); }}
                                            >
                                                {isRefundLoading ? (
                                                    <div className="registerLoader">
                                                        <div className="ring-loader"></div>
                                                    </div>
                                                ) : (
                                                    'Refund'
                                                )}
                                            </button>
                                        </div>

                                    </>
                                }

                                {
                                    signleTransactionData?.status === 'failed' &&
                                    <>

                                        <div className="suspending-process">
                                            <span className='label'>Suspending process</span>
                                            <div className="status-item completed process-one">
                                                <div className="status-icon">
                                                    <div className="circle checked" />
                                                </div>
                                                <div className="status-content">
                                                    <div className="status-title">Payment Issue - please update your payment method</div>
                                                    <div className="status-subtext">Email notification sent on April 12, 2024</div>
                                                </div>
                                            </div>
                                            <div className="status-item completed">
                                                <div className="status-icon">
                                                    <div className="circle checked" />
                                                </div>
                                                <div className="status-content">
                                                    <div className="status-title">Your account will be deleted soon</div>
                                                    <div className="status-subtext">Email notification sent on April 14, 2024</div>
                                                </div>
                                            </div>
                                            <div className="status-item pending">
                                                <div className="status-icon">
                                                    <div className="circle" />
                                                </div>
                                                <div className="status-content">
                                                    <div className="status-title">Your account has been suspended</div>
                                                    <div className="status-subtext">Email notification will be sent on April 17, 2024</div>
                                                </div>
                                            </div>
                                            <div className="status-item disabled">
                                                <div className="status-icon">
                                                    <div className="circle" />
                                                </div>
                                                <div className="status-content">
                                                    <div className="status-title">Account Suspension</div>
                                                    <div className="status-subtext">Account will be suspended on April 17, 2024</div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default EditTransaction